import { CalendarProvider } from "./CalendarContext";
import Calendar from "./Calendar";
import AppointmentFilter from "./AppointmentFilter";
import { Card, Space } from "antd";
import { t } from "i18next";
import AppointmentMenu from "./AppointmentMenu";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import { useEffect } from "react";

export default function CalendarApp() {
    useEffect(() => {
        document.title = `HIS - ${t('Calendar')}`
    }, []);

    return (
        <>
            <SimpleLayout fullWidth={true}>
                <Card>
                    <CalendarProvider>
                        <AppointmentFilter />
                        <AppointmentMenu />
                        <br />
                        <Calendar />
                    </CalendarProvider>
                </Card>
            </SimpleLayout>
        </>
    )
}